export default __webpack_public_path__ + "337ecbb418b5957c79887ee6772b6675.png";